import React from 'react';
import { TabNavigationItem } from './components/tabNavItem';
import { Tab } from './components/tabContent';

export const getChildrens = (
  children: React.ReactNode,
  selectedTab: number,
  onTabSelect: (selectedIndex: number, e?: MouseEvent | KeyboardEvent) => void
) => {
  let navigationItems = [];
  let tabContents = [];

  React.Children.forEach(children, (child: React.ReactElement<any>, index) => {
    const selected = index === selectedTab;
    const { name } = child.props;
    navigationItems.push(
      <TabNavigationItem key={index} name={name} index={index} selected={selected} onClickItem={onTabSelect} />
    );
    if (child?.props?.children) {
      tabContents.push(
        <Tab key={index} selected={selected}>
          {child.props.children}
        </Tab>
      );
    }
  });

  return { navigationItems, tabContents };
};
